import React from "react";
import dynamic from "next/dynamic";
import SmoothScroll from "@/Components/common/SmoothScroll";

const HocHead = dynamic(
  () => import("@/Components/HigherOrderComponent/HocHead"),
  { ssr: true },
);

const Hero = dynamic(() => import("./hero"), { ssr: true });
const Trusted = dynamic(() => import("./trusted"), { ssr: true });
const VerifiedClutchReviews = dynamic(() => import("./verified"), {
  ssr: true,
});
const DeliveryProcess = dynamic(() => import("./delivery-process"), {
  ssr: true,
});
const TechBuild = dynamic(() => import("./tech-build"), { ssr: true });
const TechStackSection = dynamic(() => import("./tech-stack"), { ssr: true });
const TechnologyTeam = dynamic(() => import("./technology-team"), {
  ssr: true,
});
const TechMeet = dynamic(() => import("./tech-meet"), { ssr: true });
const TechnologyExpertise = dynamic(() => import("./technology-expertise"), {
  ssr: true,
});
const AssembleTeam = dynamic(() => import("./team"), { ssr: true });
const Review = dynamic(() => import("./testimonial"), { ssr: true });
const RequestForm = dynamic(() => import("./request-form"), { ssr: false });

interface LandingPageProps {
  blocks?: any[];
  seo?: any;
}

const LandingPage: React.FC<LandingPageProps> = ({ blocks, seo }) => {
  return (
    <SmoothScroll>
      <div className="landing-page bg-one">
        {seo && <HocHead seo={seo} />}

        {blocks?.map((block: any, i: number) => {
          switch (block?.__component) {
            case "blocks.2025-home-banner":
              return <Hero key={i} data={block} />;

            case "blocks.2025-home-trusted-by":
              return <Trusted key={i} data={block} />;

            case "blocks.2025-clutch-reviews":
              return <VerifiedClutchReviews key={i} data={block} />;

            case "blocks.how-we-work":
              return <TechnologyTeam key={i} data={block} />;

            case "blocks.what-we-do":
              return <TechnologyExpertise key={i} data={block} />;

            case "blocks.2025-technology":
              return <TechStackSection key={i} data={block} />;

            case "blocks.philosophy":
              return <TechBuild key={i} data={block} />;

            case "blocks.leader-banner":
              return <TechMeet key={i} block={block} />;

            case "blocks.milestones-that-define-us":
              return <DeliveryProcess key={i} data={block} />;

            case "blocks.2025-assemble-team":
              return <AssembleTeam key={i} data={block} />;

            case "blocks.2025-testimonials":
              return <Review key={i} data={block} />;

            case "blocks.2025-home-rfp":
              return <RequestForm key={i} data={block} />;

            default:
              return (
                <div
                  key={i}
                  className="text-red-500 p-4 bg-red-50 border border-red-200 rounded-md mt-4 max-w-[1500px] mx-auto"
                >
                  Unknown block type: {block?.__component || "undefined"}
                </div>
              );
          }
        })}
      </div>
    </SmoothScroll>
  );
};

export default LandingPage;
